import { Stack } from '@bedrock-layout/stack';
import styled from 'styled-components';
import { Typography } from 'ui';
import { MdError } from 'react-icons/md';

export const Container = styled(Stack)`
  border-top: 1px solid var(--color-lightGray);
  margin-top: 0.5rem;
  padding: 1rem 0rem;
  block-size: 45rem;
  overflow-y: auto;
`;

export const TextBlue = styled(Typography)`
  color: var(--color-primary1);
`;


export const AccordionContainer = styled.div`
  width: 100%;
  max-width: 90%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  outline : none;
`;

export const AccordionHeader = styled.button<{ $isOpen: boolean }>`
  width: 100%;
  padding: 0.8rem;
  background-color: ${(props) => (props.$isOpen ? '#fef2f2' : '#ffffff')};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.2s ease;
  outline : none;
  &:hover {
    background-color: ${(props) => (props.$isOpen ? '#fee2e2' : '#f9fafb')};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
`;

export const ErrorIcon = styled(MdError)`
  color: #ef4444;
  font-size: 24px;
  flex-shrink: 0;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
`;

export const ErrorDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
`;

export const ChevronIcon = styled.div`
  color: #6b7280;
  font-size: 24px;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
`;

export const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${(props) => (props.$isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  background-color: #f9fafb;
`;

export const ErrorList = styled.ul`
  margin: 0;
  padding: 20px;
  list-style: none;
  overflow-y: scroll;
  max-height: 20rem;
`;

export const ErrorItem = styled.li`
  font-size: 1.4rem;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '•';
    color: #ef4444;
    font-weight: bold;
    margin-right: 8px;
  }
`;